import React from 'react';
import { PaymentMethod } from '@apply/constants';

interface PaymentMethodBlockParameters {
    paymentMethod: PaymentMethod;
    cardLastFourDigits: number;
}

export const PaymentMethodBlock: React.FC<PaymentMethodBlockParameters> = ({ paymentMethod, cardLastFourDigits }) => {
    let imagePath = '';

    switch (paymentMethod) {
        case PaymentMethod.Visa:
            imagePath = '/images/Visa Icon.png';
            break;
        case PaymentMethod.MasterCard:
            imagePath = '/images/MasterCard Icon.png';
            break;
    }

    return (
        <>
            {imagePath && (
                <img
                    src={imagePath}
                    height={20}
                />
            )}
            <span>&nbsp;****&nbsp;{cardLastFourDigits}</span>
        </>
    );
};
